import { Injector, runInInjectionContext } from '@angular/core';
import {
  CollectionReference,
  DocumentData,
  DocumentReference,
  DocumentSnapshot,
  onSnapshot,
  Query,
  QuerySnapshot,
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';

/** Live collection/query stream with Angular injection context preserved. */
export function fromCollectionSnapshot<T>(
  injector: Injector,
  ref: CollectionReference<DocumentData> | Query<DocumentData>,
): Observable<T[]> {
  return new Observable<T[]>(subscriber => {
    const unsub = runInInjectionContext(injector, () => onSnapshot(
      ref,
      (snap: QuerySnapshot<DocumentData>) =>
        subscriber.next(snap.docs.map(d => ({ id: d.id, ...d.data() } as T))),
      (err: Error) => subscriber.error(err),
    ));
    return unsub;
  });
}

/** Live single-document stream with Angular injection context preserved. */
export function fromDocSnapshot<T>(
  injector: Injector,
  ref: DocumentReference<DocumentData>,
  mapFn: (snap: DocumentSnapshot<DocumentData>) => T,
): Observable<T> {
  return new Observable<T>(subscriber => {
    const unsub = runInInjectionContext(injector, () => onSnapshot(
      ref,
      snap => subscriber.next(mapFn(snap)),
      (err: Error) => subscriber.error(err),
    ));
    return unsub;
  });
}
